import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const sendEmail = async (body: unknown) => $fetch<BFFResponse<void>>('/contacts/send', { method: 'POST', body: JSON.stringify(body) });

  return {
    sendEmail,
  };
};
